import template from 'text!./templates/ho-scheduled-properties-edit.html';
import PolicyChange from 'edge/endorsement/common/models/PolicyChange';

export default [function () {
    return {
        template: template,
        'restrict': 'E',
        'scope': {
            next: '&',
            wizard: '=' // Although we work with the scheduledProperties only, the whole model is needed for validation of unique descriptions
        },
        'controller': ['$scope', 'endorsement.EndorsementService', 'ViewModelService', function ($scope, EndorsementService, ViewModelService) {
            $scope.scheduleStatus = {
                loaded: true
            };

            /**
             * Next button is clicked
             */
            $scope.onNext = function () {
                // Call next method on parent
                $scope.next();
            };

            $scope.onChange = function () {
                $scope.scheduleStatus.loaded = false;
                EndorsementService.saveEndorsement($scope.wizard.model.policyChange).then(function (pc) {
                    $scope.wizard.model.policyChange = new PolicyChange(pc);
                    $scope.wizard.viewModel = ViewModelService.create($scope.wizard.model.policyChange, 'pc', 'edge.capabilities.policychange.dto.PolicyChangeDataDTO');
                    $scope.scheduleStatus.loaded = true;
                });
            };
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/endorsement/ho/directives/HOScheduledPropertiesEdit.js
// module id = 1461
// module chunks = 0